import type { Document } from "@apps/gwservice/types"
import { AttachmentBlock } from "./attachment-block"

interface AttachmentListProps {
  attachments?: (Document | undefined)[]
  className?: string
}

export function AttachmentList({ attachments, className }: AttachmentListProps) {
  const docs = attachments?.filter((d): d is Document => d !== undefined) ?? []
  if (!docs.length) return null

  return (
    <div className={`flex flex-col gap-s px-m pt-s ${className || ""}`}>
      {docs.map((doc) => (
        <AttachmentBlock key={doc.id} document={doc} />
      ))}
    </div>
  )
}
